export default __webpack_public_path__ + "static/media/2.270e37c6.jpg";